import { render, staticRenderFns } from "./Outlook.vue?vue&type=template&id=5f2021a4&scoped=true&"
import script from "./Outlook.vue?vue&type=script&lang=js&"
export * from "./Outlook.vue?vue&type=script&lang=js&"
import style0 from "./Outlook.vue?vue&type=style&index=0&id=5f2021a4&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2021a4",
  null
  
)

export default component.exports